<template>
	<div>
		<v-dialog v-model="dialog_add_product" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
				    <v-toolbar-title class="white--text">Add Item</v-toolbar-title>
				    <v-spacer></v-spacer>
				    <v-btn round-borders outline @click="fn_checkValidations">Done</v-btn>
				</v-toolbar>
        		<!-- <v-divider></v-divider> -->
        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width>
        	  			<v-layout wrap padding-top-bottom-ten white-background>

							<v-flex xs12 sm12 md12 align-msg-right form-item
					        	@click="$parent.fn_openProducts('android', 'ProductList', 'ref_fieldProductName')">

				               <v-text-field  
					               	readonly
                                    :hide-details="true"
					               	v-model="$parent.Form.productName" 
					               	label="Select Product" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	:onUpdate="$parent.fn_updateProduct"
					               	ref="ref_fieldProductName"
					               	v-validate="'required'" 
				               		data-vv-name="product" 
				               		:error-messages="errors.collect('fields.product')"
				               		required>
				               </v-text-field>

				               <div custom-message>
				               		<span v-for="(item, index) in $parent.Form.summaryArray" v-if="$parent.Form.summaryArray.length">
	               						Stock: <span :class="{'redcolor':item.qty<0}">{{item.qty}} {{item.unitName}}</span>
				               		</span>
				               </div>
				            </v-flex>

							<template v-if="$parent.Form.productData">
								<v-flex xs6 sm6 md6 form-item>
									<v-text-field 
										v-model="$parent.Form.qty"
										:disabled="$parent.Form.productData && $parent.Form.productData.batches && $parent.Form.productData.batches.length ? true : false"
										label="Qty" 
										placeholder=" "
										type="number"
										v-validate="'required|decimal:3'" 
										data-vv-name="qty" 
										:error-messages="errors.collect('fields.qty')">
									</v-text-field>
								</v-flex>

								<v-flex xs6 sm6 md6 form-item>
									<v-text-field 
										v-model="$parent.Form.averageRate"
										label="Rate" 
										placeholder=" "
										type="number"
										v-validate="'decimal:2'" 
										data-vv-name="rate" 
										:error-messages="errors.collect('fields.rate')">
									</v-text-field>
								</v-flex>
							</template>

							<template v-if="$parent.Form.averageRate">
								<v-flex pr-3 xs12 sm12 md12 right-align>Rate: {{ $root.numberToLocale($parent.Form.averageRate) }}</v-flex>
								<v-flex pr-3 xs12 sm12 md12 right-align>Amount: &#8377; {{ $root.numberToLocale($parent.Form.averageRate * $parent.Form.qty) }}</v-flex>
							</template>

						</v-layout>
						
						<div class="pt-2 pb-2 grey-back full-width" v-if="$parent.Form.productData">
							<template v-if="$parent.hasSeries && !$parent.hasOnlySeries && $root.TransactionSettings.enableBatch">
								<v-radio-group class="pt-3 pl-3 pr-3 pb-1" white-background hide-details v-model="$parent.Form.selectedBatchType" row @change="$parent.fn_changeBatchType($event, $parent.Form.productData)">
									<v-radio label="Batch" :value="1"></v-radio>
									<v-radio label="Series" :value="2"></v-radio>
								</v-radio-group>
								<v-divider></v-divider>
							</template>

							<v-subheader class="white-background" v-if="$root.TransactionSettings.enableBatch || ($parent.Form.productData.batches && $parent.Form.productData.batches.length)">
								<!-- {{ seriesFields }} -->
								<template v-if="$parent.Form.selectedBatchType == 2"><span v-for="(field, index) in $parent.seriesFields" :key="field.title">{{ field.title }}<span v-if="$parent.seriesFields.length - 1 != index">/</span></span></template>
								<template v-else>Batches</template>
									<v-spacer></v-spacer> 
								<!-- <v-btn color="primary" capitalize class="mr-0" @click="fn_openDialogSelectBatch">Select/Add</v-btn>  -->
								
								<template v-if="$root.TransactionSettings.enableBatch">
									<!-- <v-btn v-if="product.baseTransactionListId == 10003 && $parent.settings.transactionTypeId == 10004" small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="$parent.fn_openDialogReturnForm('ref_dialogReturnForm')">
										<v-icon class="mr-1" font16 color="primary">edit</v-icon> Change Batch Quantity
									</v-btn> -->

									<v-btn small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="$parent.fn_openDialogSelectBatch">
										<v-icon class="mr-1" font16 color="primary">add</v-icon> Add / Select
									</v-btn>
								</template>
								<!-- <v-btn color="primary"  capitalize flat class="mr-0" @click="fn_newBatch">New Batch <v-icon color="primary" class="ml-1">add</v-icon></v-btn> -->
							</v-subheader>
							<template v-if="$parent.Form.productData">
								<v-card flat v-for="(batch, batchIndex) in $parent.Form.productData.batches" :key="batchIndex" v-if="$parent.fn_showHideBatches(batch)">
									<v-divider></v-divider>
									<v-card-text class="pb-2">
										<div style="float: left;margin-right: 12px;">
											<v-btn small nomargin icon flat @click="$parent.fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
										</div>
										<v-layout class="batch_layout" row wrap>
											<!-- <v-flex xs4 sm4 md4 mb-2 v-for="(field, fieldIndex) in $root.TransactionSettings.batchFields" :key="fieldIndex" v-if="field.id != 'opening' && $parent.fn_fieldVisibilty(field, $parent.Form.selectedBatchType)">
												<div light-opacity-color>{{ field.title }}</div>
												<div v-if="field.type == 'date'">{{ batch[field.id] | moment('DD-MMM-YYYY') }}</div>
												<div v-else>{{ batch[field.id] }}</div>
											</v-flex> -->
											<!-- <v-flex xs2 sm2 md2 mb-2 v-if="(product.baseTransactionListId != 10003 && $parent.settings.transactionTypeId == 10004) || $parent.settings.transactionTypeId == 10002 || $parent.settings.transactionTypeId == 10003">
												<v-btn small nomargin icon flat @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
											</v-flex> -->
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
												<div light-opacity-color>Batch No.</div>
												<div>{{ batch.batchNumber }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
												<div light-opacity-color>Size</div>
												<div>{{ batch.batchSize }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
												<div light-opacity-color>MRP</div>
												<div>{{ batch.batchMRP }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
												<div light-opacity-color>Mfg. Date</div>
												<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
												<div light-opacity-color>Exp. Date</div>
												<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
												<div light-opacity-color>Purchase Rate</div>
												<div>{{ batch.purchaseRate }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
												<div light-opacity-color>Serial Number</div>
												<div>{{ batch.field1 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
												<div light-opacity-color>IMEI Number</div>
												<div>{{ batch.field2 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
												<div light-opacity-color>Part Number</div>
												<div>{{ batch.field3 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
												<div light-opacity-color>Model Number</div>
												<div>{{ batch.field4 }}</div>
											</v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="$parent.Form.selectedBatchType == 1 && ($parent.Form.productData.batches.length > 1 || ($parent.Form.productData.batches.length == 1 && batch.productQty != $parent.Form.productData.productVariants[0].qty))">
												<div light-opacity-color>Quantity</div>
												<div>{{ batch.productQty }}</div>
											</v-flex>
										</v-layout>

										<!-- <v-layout row wrap :style="{'paddingLeft':product.baseTransactionListId == 10003 && $parent.settings.transactionTypeId == 10004 ? '0px' : '40px'}" v-if="$parent.Form.selectedBatchType == 1">
											<v-flex xs6 sm6 md6>
												<v-text-field
													label="Quantity"
													:disabled="!$root.TransactionSettings.enableBatch"
													v-model.number="batch.productQty"
													:hint="batch.billQty != undefined ? 'Bill Qty: ' + batch.billQty : ''"
													@input="fn_changeBatchQty(batch)"
													type="number"
													placeholder=" "
													v-validate="'min_value:0'" 
													data-vv-name="qty" 
													:hide-details="!errors.has('fields.qty') || !batch.billQty"
													:error-messages="errors.collect('fields.qty')"
												></v-text-field>
											</v-flex>
											
											<v-flex xs6 sm6 md6 pl-3>
												<v-text-field
													label="Unit"
													:disabled="true"
													:hide-details="!errors.has('fields.qty')"
													:value="$parent.Form.productData.items[0].productVariants[0].selectedUnit ? $parent.Form.productData.items[0].productVariants[0].selectedUnit.itemName : $parent.Form.productData.items[0].productVariants[0].unitName"
												></v-text-field>
											</v-flex>

											<v-flex xs12 sm12 md12 pt-1 pb-1 pr-2 right-align :class="{'error_background redcolor':batch.currentStock<0}">
												Current Stock: {{ batch.currentStock ? roundUpto2Decimals(batch.currentStock) : 0 }} {{ $parent.Form.productData.items[0].productVariants[0].primaryUnitName }}
											</v-flex>

											<v-flex xs12 sm12 md12 redcolor pb-2 pt-2 v-if="batch.expDate && $parent.fn_checkDate(batch)">
												<v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ $parent.fn_getDate(batch) }}
											</v-flex>
										</v-layout> -->
									</v-card-text>
								</v-card>
								
							</template>

						</div>

						
        	  		</v-form>
        	  		
        	  	</v-card-text>

	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>
export default{
	data(){	
		return{
			dialog_add_product: false,
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.dialog_add_product = true;
		},
		closeDialogWeb: function () {
			this.dialog_add_product = false;
		},
		fn_checkValidations: function(){
			this.$validator.validateAll('fields').then((result) => {
		        if (result) {
                    let obj = {};
                    obj.productId = this.$parent.Form.productId;
                    obj.productName = this.$parent.Form.productName;
                    obj.qty = this.$parent.Form.qty;
                    // obj.currentStock = this.$parent.Form.qty;
                    obj.unitId = this.$parent.Form.productData.productVariants[0].unitId;
                    obj.unitName = this.$parent.Form.productData.productVariants[0].unitName;
                    obj.productVariantId = this.$parent.Form.productData.productVariants[0].productVariantId;
                    obj.primaryUnitId = this.$parent.Form.productData.productVariants[0].primaryUnitId;
                    obj.secondaryUnitId = this.$parent.Form.productData.productVariants[0].secondaryUnitId;
                    obj.packQuantity = this.$parent.Form.productData.productVariants[0].packQuantity;
                    obj.secondaryUnitPackQuantity = this.$parent.Form.productData.productVariants[0].secondaryUnitPackQuantity;
					obj.averageRate = this.$parent.Form.averageRate;

					obj.selectedBatchType = this.$parent.Form.selectedBatchType;

					obj.batches = this.$parent.Form.productData.batches && this.$parent.Form.productData.batches.length ? this.$parent.Form.productData.batches : null;

					// filtering batches as per selected batch type (batch/series)
					if(obj.batches && obj.batches.length){
						obj.batches = obj.batches.filter(batch=>{
							if(obj.selectedBatchType == 1){
								return batch.batchNumber || batch.batchMRP || batch.purchaseRate || batch.batchSize || batch.mfgDate || batch.expDate || batch.opening || batch.field4
							}
							else{
								return  batch.field1 || batch.field2 || batch.field3
							}
						});
					}

                    // let itemIndex = this.$parent.Form.transactionProducts.findIndex(item=>{return item.productId == this.$parent.Form.productId});
                    // if(itemIndex == -1){
                    //     this.$parent.Form.transactionProducts.push(obj);
                    // }
                    // else{
					// 	this.$set(this.$parent.Form.transactionProducts, itemIndex,  JSON.parse(JSON.stringify(obj)));
                    // }

					if(this.$parent.Form.selectedItemIndex != null){
						this.$set(this.$parent.Form.transactionProducts, this.$parent.Form.selectedItemIndex,  JSON.parse(JSON.stringify(obj)));
					}
					else{
						this.$parent.Form.transactionProducts.push(obj);
					}
		           	
                    this.$parent.fn_closeDialog();
		        }
		        else{
		        	this.showToast("Please enter valid details");
		        }
		    });
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_transfer/dialogs/dialog_product.vue